import React, { useContext } from "react";
import _ from "lodash";
import { Utils, UserContext } from "./../common";

const Logout = (props) => {
  const { userData, logout } = useContext(UserContext);
  const logMeOut = () => {
    logout(() => {
      window.location.href = "/";
    });
  };

  return <>{logMeOut()}</>;
};
export default Logout;
